import SectionLabel from "../ui/SectionLabel";
import Marquee from "../ui/Marquee";
import ScrollReveal from "../motion/ScrollReveal";

const row1 = ["React.js", "Next.js", "TypeScript", "Node.js", "Python", "FastAPI", "PostgreSQL", "MongoDB", "Redis", "Docker", "AWS", "Google Cloud"];
const row2 = ["OpenAI GPT-4o", "Claude 3.5", "Gemini Pro", "LangChain", "CrewAI", "Pinecone", "n8n", "Twilio", "ElevenLabs", "Vapi.ai", "Razorpay", "WhatsApp API"];

export default function TechStack() {
  return (
    <section style={{ background: "#050505", padding: "80px 0" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto 36px", padding: "0 40px" }}>
        <ScrollReveal direction="up">
          <SectionLabel text="OUR TECHNOLOGY STACK" />
        </ScrollReveal>
      </div>
      <ScrollReveal direction="none" delay={0.15}>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <Marquee items={row1} direction="left" speed={35} />
          <Marquee items={row2} direction="right" speed={45} />
        </div>
      </ScrollReveal>
      <div style={{ maxWidth: 1280, margin: "36px auto 0", padding: "0 40px", textAlign: "center" }}>
        <ScrollReveal direction="up" delay={0.25}>
          <p
            style={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 300,
              fontStyle: "italic",
              fontSize: 14,
              color: "#908A83",
            }}
          >
            We choose the right tool for each project — not the same stack for every client.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
